import React from "react";
import { Link } from "react-router-dom";

export default function ResourcesHeroIntroSection() {
  return (
    <>
      <p className="twentytwentysix-content__eyebrow">The Mamahood</p>
      <h1 className="twentytwentysix-content__title">Stories &amp; Resources</h1>
      <p className="twentytwentysix-content__copy">
        Essays, guides, and conversations for moms in the thick of it. Vetted by
        the community, written for real life.
      </p>
      <div className="twentytwentysix-content__cta-row">
        <Link to="/twentytwentysix" className="twentytwentysix-content__pill">
          Back to Home
        </Link>
      </div>
    </>
  );
}

